"use client";

import {
    LogOut,
    MenuIcon,
} from "lucide-react";
import { Button } from "@/components/shared/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/shared/ui/sheet";
import { useState, useEffect } from "react";
import { Link, usePathname } from "@/navigation";
import { useTranslations } from "next-intl";
import { navbarLinks } from "@/constants/navbar";
import useAuthStore from "@/store/authStore";

function MobileNavbar() {
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const { isAuthenticated, logout } = useAuthStore()

    const t = useTranslations('Navbar');
    const pathname = usePathname();

    // Helper function to close the menu
    const handleLinkClick = () => {
        setShowMobileMenu(false);
    };

    return (
        <div className="flex lg:hidden items-center space-x-2">
            <Sheet open={showMobileMenu} onOpenChange={setShowMobileMenu}>
                <SheetTrigger asChild className="cursor-pointer">
                    <MenuIcon className="w-6 h-6" color="#005b96" />
                </SheetTrigger>
                <SheetContent side="left" className="w-[300px]">
                    <SheetHeader>
                        <SheetTitle>{t('menu')}</SheetTitle>
                    </SheetHeader>

                    <nav className="flex flex-col space-y-4 mt-6 items-start justify-start w-full">
                        {navbarLinks.map((link, index) => {
                            return (
                                <div key={index}>
                                    <Button
                                        variant="ghost"
                                        asChild
                                        onClick={handleLinkClick}
                                    >
                                        <Link href={link.href}>
                                            <span className={`font-bold ${pathname === link.href ? "text-primary" : ""}`} >
                                                {t(link.name)}
                                            </span>
                                        </Link>
                                    </Button>
                                </div>
                            )
                        })}
                        {isAuthenticated ? (
                            <Button
                                variant="ghost"
                                className="gap-2 w-full cursor-pointer hover:text-red-600"
                                asChild
                                onClick={() => {
                                    logout()
                                    handleLinkClick()
                                }}
                            >
                                <div>
                                    <LogOut className="w-6 h-6  " />
                                    <span>{t('logout')}</span>
                                </div>
                            </Button>
                        ) : (
                            <>
                                <Button
                                    variant="sub_primary"
                                    className="flex items-center gap-2 w-full py-sub_text px-6 rounded-full"
                                    asChild
                                    onClick={handleLinkClick}
                                >
                                    <Link href="/auth/signup">
                                        <span>{t('signup')}</span>
                                    </Link>
                                </Button>

                                <Button
                                    variant="sub_secondary"
                                    className="flex items-center gap-2 w-full py-sub_text px-6 rounded-full"
                                    asChild
                                    onClick={handleLinkClick}
                                >
                                    <Link href="/auth/login">
                                        <span>{t('login')}</span>
                                    </Link>
                                </Button>
                            </>
                        )}
                    </nav>
                </SheetContent>
            </Sheet>
        </div>
    );
}

export default MobileNavbar;